import styled from 'styled-components'

export const SplitTextOuter = styled.span`
  display: block;
`

export const SplitTextWrapper = styled.span`
  display: inline-block;

  .split__mask {
    display: inline-block;

    em,
    span.em {
      display: inline-block;
      font-style: italic;
      line-height: 1.1;
      white-space: nowrap;
    }

    i.sup {
      font-size: 50%;
      vertical-align: super;
    }
  }
`
